

<template>
  <v-container class="justify-center">
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          item-text="reportName"
          item-value="reportValue"
          v-model="reportSelected"
          :items="reportList"
          chips
          label="ประเภทรายงาน"
          clearable
          outlined
          dense
        >
        </v-autocomplete>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              v-model="computedStartDateFormatted"
              label="วันที่สร้างเริ้มต้น"
              persistent-hint
              prepend-inner-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || 'ระบุ วันเริ่มต้น ']"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            no-title
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              v-model="computedEndDateFormatted"
              label="วันที่สร้างสิ้นสุด"
              persistent-hint
              prepend-inner-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || 'ระบุ วันสิิ้นสุด ']"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            no-title
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
        <v-autocomplete
          v-if="ConditionParam('company')"
          v-model="companySelected"
          :items="companyList"
          chips
          label="บริษัท"
          multiple
          clearable
          outlined
          dense
        >
        </v-autocomplete>
        <v-autocomplete
          v-if="ConditionParam('org')"
          v-model="orgSelected"
          :items="orgList"
          chips
          label="สายงาน"
          multiple
          clearable
          outlined
          dense
        >
        </v-autocomplete>
        <v-autocomplete
          v-if="ConditionParam('branch')"
          v-model="branchSelected"
          :items="branchList"
          chips
          label="ฝ่าย"
          multiple
          clearable
          outlined
          dense
        >
        </v-autocomplete>
        <v-autocomplete
          v-if="ConditionParam('type')"
          v-model="typeSelected"
          :items="typeList"
          item-text="typeName"
          item-value="typeValue"
          chips
          label="ประเภท"
          multiple
          clearable
          outlined
          dense
        >
        </v-autocomplete>
        <v-autocomplete
          v-if="ConditionParam('status')"
          v-model="statusSelected"
          :items="statusList"
          item-text="statusName"
          item-value="statusValue"
          chips
          label="สถานะ"
          multiple
          clearable
          outlined
          dense
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <div 
      v-if="reportSelected"
      class="text-center">
        <v-menu offset-x>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              สร้างรายงาน
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                ><v-btn
                  rounded
                  color="primary"
                  dark
                  @click="GenerateReport('pdf')"
                >
                  PDF
                </v-btn></v-list-item-title
              >
              </v-list-item>
              <v-list-item>
              <v-list-item-title
                ><v-btn
                  rounded
                  color="primary"
                  dark
                  @click="GenerateReport('xlsx')"
                >
                  EXCEL
                </v-btn></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-row>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      reportList: [
        {
          reportName: "รายงานการสร้าง Make It Simple",
          reportValue: "Report_Detail_Manual",
        },
        // {
        //   reportName: "รายงานสรุปภาพรวม",
        //   reportValue: "Report_OverAll",
        // },
        // {
        //   reportName: "รายงานสรุปฝ่าย",
        //   reportValue: "Report_Branch",
        // },
        // {
        //   reportName: "รายงานรายละเอียดการสร้าง",
        //   reportValue: "Report_Detail",
        // },
      ],
      reportSelected: "Report_Detail_Manual",
      companyList: [],
      orgList: [],
      branchList: [],
      companySelected: [],
      orgSelected: [],
      branchSelected: [],
      statusList: [
        {
          statusName: "เสร็จ 100% (ไม่ส่งตรวจ)",
          statusValue: "finish_not_submit",
        },
        { statusName: "ระหว่างดำเนินการ", statusValue: "in_progress" },
        { statusName: "รอตรวจรับ", statusValue: "submit" },
        { statusName: "ตรวจรับผ่าน", statusValue: "approve" },
        { statusName: "ตรวจรับไม่ผ่าน", statusValue: "reject" },
        { statusName: "ยกเลิก", statusValue: "cancel" },
      ],
      statusSelected: [],
      typeList: [
        {
          typeName: "เดี่ยว",
          typeValue: "solo",
        },
        {
          typeName: "ทีม",
          typeValue: "team",
        },
      ],
      typeSelected: [],
      startDate: this.addDays(new Date().toISOString().substr(0, 10), -60)
        .toISOString()
        .substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
    };
  },
  async created() {
    this.orgList = await this.OrgLookup();
    this.branchList = await this.BranchLookup();
    this.companyList = await this.CompanyLookup();
  },
  methods: {
    ConditionParam(field) {
      switch (this.reportSelected) {
        case "Report_OverAll":
          if (["company", "org", "branch"].indexOf(field) > -1) {
            return true;
          } else {
            return false;
          }
          break;
        case "Report_Branch":
          break;
        case "Report_Detail":
          break;
        case "Report_Detail_Manual":
          return true;
          break;

        default:
          break;
      }
    },
    GenerateReport(type) {
      let urlReporting = `https://reporting.lpn.co.th/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2FReports%2FMakeItSimpleV2&reportUnit=%2FReports%2FMakeItSimpleV2%2FDetail_Manual&standAlone=true&j_username=reportviewer&j_password=Dev@2019&output=${type}&sdate=${
        this.startDate
      }&edate=${this.endDate}&subjectStatus=${this.statusSelected.join(
        ","
      )}&subjectType=${this.typeSelected.join(",")}&org=${this.orgSelected.join(
        ","
      )}&branch=${this.branchSelected.join(",")}
      &company=${this.companySelected.join(",")}`;

      window.open(urlReporting);
    },
    formatDate(date) {
      if (!date) return null;

      let [year, month, day] = new Date(date)
        .toISOString()
        .substr(0, 10)
        .split("-");
      return `${day}/${month}/${year}`;
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
  },
  computed: {
    computedStartDateFormatted() {
      // console.log(this.startDate);
      return this.formatDate(this.startDate);
    },
    computedEndDateFormatted() {
      return this.formatDate(this.endDate);
    },
  },
};
</script>

<style>
</style>